/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs */

const en_campaigns_mag7_spacex_fine_print_custody = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokenized stocks remain in your own wallet. You retain full ownership of the underlying assets at all times.`)
};

const de_campaigns_mag7_spacex_fine_print_custody = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die tokenisierten Aktien verbleiben in Ihrer eigenen Wallet. Sie behalten jederzeit das volle Eigentum an den zugrunde liegenden Assets.`)
};

const pt_br2_campaigns_mag7_spacex_fine_print_custody = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As ações tokenizadas permanecem na sua própria carteira. Você mantém a propriedade total dos ativos subjacentes o tempo todo.`)
};

const tr_campaigns_mag7_spacex_fine_print_custody = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokenleştirilmiş hisseler kendi cüzdanınızda kalır. Dayanak varlıkların tam mülkiyeti her zaman sizde olur.`)
};

const zh_cn2_campaigns_mag7_spacex_fine_print_custody = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代币化股票始终保存在你自己的钱包中，你随时对底层资产拥有完整所有权。`)
};

const zh_hk2_campaigns_mag7_spacex_fine_print_custody = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代幣化股票一直存放在你自己的錢包中，你隨時對相關資產擁有完整擁有權。`)
};

const ko_kr2_campaigns_mag7_spacex_fine_print_custody = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`토큰화된 주식은 본인 지갑에 그대로 보관됩니다. 기초 자산의 완전한 소유권은 항상 사용자에게 있습니다.`)
};

const ru_ru2_campaigns_mag7_spacex_fine_print_custody = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Токенизированные акции остаются в вашем собственном кошельке. Полное право собственности на базовые активы всегда сохраняется за вами.`)
};

const es_419_campaigns_mag7_spacex_fine_print_custody = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las acciones tokenizadas permanecen en tu propia billetera. Conservas la propiedad total de los activos subyacentes en todo momento.`)
};

/**
* | output |
* | --- |
* | "Tokenized stocks remain in your own wallet. You retain full ownership of the underlying assets at all times." |
*
* @param {Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_fine_print_custody = /** @type {((inputs?: Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Fine_Print_CustodyInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_fine_print_custody(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_fine_print_custody(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_fine_print_custody(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_fine_print_custody(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_fine_print_custody(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_fine_print_custody(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_fine_print_custody(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_fine_print_custody(inputs)
	return es_419_campaigns_mag7_spacex_fine_print_custody(inputs)
});